import mutations from './mutations'
import writeoffForms from '@/api/writeoffForms'

import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'writeoffForms'

export default {
  namespaced: true,

  state: {
    items: {},
    filters: null
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    /* articleMargin ({ rootState }, { acceptanceFormId, params }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        acceptanceForms.articleMargin({ businessUnitId, id: acceptanceFormId, params })
          .then(response => {
            const article = response.data.items[0]
            resolve(article)
          })
          .catch(error => reject(error))
      })
    }, */
    setFilters ({ commit, state }, filters) {
      return new Promise((resolve) => {
        commit('updateFilters', filters)
        resolve()
      })
    },
    getPdf ({ rootState }, filters) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        writeoffForms.getPDFList({ businessUnitId, ...filters })
          .then(response => {
            resolve(response)
          })
          .catch(err => reject(err))
      })
    },
    getPdfSamostojen ({ rootState }, writeOffId) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        writeoffForms.getPDFSamostojen({ businessUnitId, writeOffId })
          .then(response => {
            resolve(response)
          })
          .catch(err => reject(err))
      })
    }
  },

  mutations: {
    ...mutations,
    updateFilters (state, filters) {
      state.filters = filters
    }
  }
}
